import styled from "styled-components";
import { mobile } from "../responsive";
import StyledLink from "../StyledLink";

const Container = styled.div`
    flex: 1;
    margin: 3px;
    height: 70vh;
    position: relative;
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${mobile({ height: "20vh" })}
`
const Info = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;

`
const Title = styled.h1`
    color: white;
    margin-bottom: 20px;
`
const Button = styled.button`
    border: none;
    padding: 10px;
    background-color: white;
    color: gray;
    cursor: pointer;
    font-weight: 600;
`
const CategoryItem = ({el}) => {
    return(
        <Container >
           <Image src={el.img} />
           <Info>
                <Title>{el.title}</Title>
                <Button><StyledLink to="/productList">SHOP NOW</StyledLink> </Button>

           </Info>
        </Container>
    )
}

export default CategoryItem;